import HUB_PAGES from 'app/constants/sections.constant'

export const getCurrentPage = () => {
  const { href } = window.location
  const currentPage = Object.values(HUB_PAGES).find((hubPage) =>
    href.includes(hubPage.href)
  )
  return currentPage ? currentPage.eventName : HUB_PAGES.HOME.eventName
}
